export default __webpack_public_path__ + "images/6G.27b6cba.png";